export const environment = {
  fb: {
    projectId: 'tada-done',
    apiKey: 'AIzaSyDGX6-TCqxyZv3m1avbP8-hZxD2-Zb6bXk',
    authDomain: 'dev.tadone.app',
    storageBucket: 'tada-done.firebasestorage.app',
    messagingSenderId: '643183149560',
    vapid:
      'BLAV3z3pqhEZkOgA31cPV7Rrk41fIt7vPAL4sir5yR5oqH9-etNKh9OGl4lC6WMMLJI3kobzv7zqb-vZfCDLNXE',
    appId: '1:643183149560:web:f7d4137a0d990b5588560d',
    appCheck: '6Ld-spkqAAAAAEkl4hBMDARhptWotnmTiOwdu-cc',
    measurementId: 'G-8T8XB487KW',
  },
  version: '1.5.0',
  production: false,
  useEmulators: false,
  /** Origin for CDN-served theme CSS, fonts and illustrations. */
  cdn: 'https://cdn.tadone.app',
} as const;
